import type { ReactNode } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { PATH_AUTH } from '../routes/paths';
import LoadingScreen from '../components/LoadingScreen';
import useMaybeSwitchTeams from 'src/hooks/useMaybeSwitchTeams';
import { buildLoginPathWithRedirect } from 'src/utils/loginRedirect';

type AuthProtectProps = {
  children?: ReactNode;
};

export default function AuthProtect({ children }: AuthProtectProps) {
  const {
    isLoading,
    isAuthenticated,
    pendingVerification,
    isOrgModerationEnabled,
  } = useAuth() as any;
  const maybeSwitch = useMaybeSwitchTeams();
  const location = useLocation();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (pendingVerification && isOrgModerationEnabled) {
    return <Redirect to={PATH_AUTH.register.pendingVerification} />;
  }

  if (!isAuthenticated) {
    // Carry the requested page through login, otherwise an emailed donation
    // link drops the user on the dashboard root with no way back to it.
    return (
      <Redirect to={buildLoginPathWithRedirect(PATH_AUTH.login, location)} />
    );
  }

  if (maybeSwitch) {
    return maybeSwitch;
  }

  return children;
}
